import React, { useContext, useEffect } from 'react';
import Header from "../common/components/header/index";
import { IndexData } from '../common/index-context';
import { WithLangData } from '../common/lang-data';
import CustomizeQuestionsModal from "../common/components/customize-questions-modal/customize-questions-modal";
import Comparisons from "./components/comparisons";
import EntityModal from "./components/entity-modal/index";

const AppInner = () => {
  const {
    init, data, loadData, openConceptAfterReload,
    showEntityModal, customizedQuestionData
  } = useContext(IndexData);

  useEffect(() => {
    loadData(null, null, null, null, {}, openConceptAfterReload);
  }, []);

  const reports = [
    {
      title: 'Concept Comparison Report',
      name: 'concept_comparison_concepts_test',
      kinds: [ 'pptx', 'xlsx' ],
      customFontSize: true
    },
    { title: 'Concept Comparison - 5-point Scales Report', name: 'five_point', kinds: [ 'xlsx' ] },
    { title: 'Individual Concept Reports', name: 'concepts_test_individual_concept', kinds: [ 'pptx', 'xlsx' ] },
    { title: 'All Concepts Verbatims Report', name: 'concepts_test_all_verbatims', kinds: [ 'xlsx' ] }
  ];
  if (init.isInternal) {
    reports.push({ title: 'Disqualified Respondents Report', name: 'disqualified', kinds: [ 'xlsx' ] });
    reports.push({ title: 'All Respondents Answers', name: 'concepts_test_all_respondents', kinds: [ 'xlsx' ] });
    reports.push({ title: 'Completes & Disqualified Report', name: 'completes_disqualified', kinds: [ 'xlsx' ] });
    reports.push({ title: 'Quota Details', name: 'quotas_details', kinds: [ 'xlsx' ] });
  }

  const sortGroups = [ 'five_point_scale', 'custom_metric', 'attribute_ratings', 'preference' ];
  sortGroups.push({ group_name: 'custom_metric', custom: 'custom_metrics' });

  return (
    <div className="content -loading-wrapper tour-parent-header">
      <Header
        reports={ reports }
        plural="concepts"
        sortGroups={ sortGroups }
      />
      <WithLangData
        langCode={ data.language_code }
        langName={ data.language_name }
      >
        <Comparisons />
        { showEntityModal && <EntityModal /> }
        { customizedQuestionData && <CustomizeQuestionsModal /> }
      </WithLangData>
    </div>
  );
};

export default AppInner;
